import React from 'react';
import { CursorContent } from './CursorContent';
import { GlobalState } from './GlobalState';
import { MousePosition } from './MousePosition';
import { ScrollPosition } from './ScrollPosition';

const providers = [
  <CursorContent.Provider />,
  <GlobalState.Provider />,
  <MousePosition.Provider />,
  <ScrollPosition.Provider />,
];

const Store = ({ children: initial }) =>
  providers.reduce(
    (children, parent) => React.cloneElement(parent, { children }),
    initial
  );

export { Store, CursorContent, GlobalState, MousePosition, ScrollPosition };
